//@flow
import { UnthemedStatistic } from './Statistic';
import { themr } from 'react-css-themr';
import StatisticUnitConnectHOC from './StatisticUnitConnectHOC';
import theme from './Statistic.scss';

export default themr(
    'Statistic',
    theme
)(StatisticUnitConnectHOC(UnthemedStatistic));
